import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span className="icon fa-bolt"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>QUANTUM CHALK</h1>
                <p>thinking about thinking</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a onClick={() => {props.onOpenArticle('intro')}}>About</a></li>
                <li><a onClick={() => {props.onOpenArticle('technology')}}>Technology</a></li>
                <li><a onClick={() => {props.onOpenArticle('products')}}>Products</a></li>
                <li><a onClick={() => {props.onOpenArticle('solutions')}}>Solutions</a></li>
                <li><a onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
